export const Language = {
   VIETNAMESE: 've',
   CHINESE: 'ch',
   LAO: 'lo',
   ENGLISH: 'en'
}

export const DEFAULT_LANGUAGE = Language.LAO
